module.exports = __webpack_public_path__ + "img/Arrow_Left.52e6199d.svg";